import * as tslib_1 from "tslib";
import { IgrSummaryRow } from "./igr-summary-row";
import { SummaryRowSection } from "./SummaryRowSection";
var IgrSummaryRowSection = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(IgrSummaryRowSection, _super);
    function IgrSummaryRowSection(props) {
        return _super.call(this, props) || this;
    }
    IgrSummaryRowSection.prototype.createImplementation = function () {
        return new SummaryRowSection();
    };
    Object.defineProperty(IgrSummaryRowSection.prototype, "i", {
        /**
                                     * @hidden
                                     */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    return IgrSummaryRowSection;
}(IgrSummaryRow));
export { IgrSummaryRowSection };
//# sourceMappingURL=igr-summary-row-section.js.map
